import styled from 'styled-components'

export const FieldLabel = styled.span`
  margin: 0 8px;
`

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  > svg:last-child {
    margin-left: auto;
  }
`
